import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';


@Component({
  selector: 'sz-modal',
  standalone: true,
  imports: [],
  template: `
    <dialog #dialogEl
      class="sz-modal-dialog rounded-xl shadow-xl border border-neutral-200 p-0 backdrop:bg-black/40"
      [style.width]="width" [style.max-width]="maxWidth || '90vw'" [style.height]="height"
      (close)="onClose()" (click)="onBackdropClick($event)">
      <div class="flex flex-col h-full">
        @if (showTitle) {
          <div class="flex items-center justify-between px-6 py-4 border-b border-neutral-200">
            <h2 class="text-lg font-semibold text-neutral-900">{{ title }}</h2>
            @if (showCloseButton) {
              <button (click)="close()" class="text-neutral-400 hover:text-neutral-600 transition-colors">
                <i class="fa fa-times text-lg"></i>
              </button>
            }
          </div>
        }
        <div class="flex-1 overflow-y-auto">
          <ng-content></ng-content>
        </div>
        <ng-content select="[szModalFooter]"></ng-content>
      </div>
    </dialog>
  `,
  styles: [`
    .sz-modal-dialog::backdrop { background: rgba(0,0,0,0.4); }
    .sz-modal-dialog { max-height: 90vh; margin: auto; }
  `]
})
export class SzModalComponent implements OnChanges {
  @Input() visible = false;
  @Input() title = '';
  @Input() showTitle = true;
  @Input() width = '500px';
  @Input() maxWidth = '90vw';
  @Input() height: string | null = null;
  @Input() showCloseButton = true;
  @Input() hideOnOutsideClick = true;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onHidden = new EventEmitter<void>();
  @ViewChild('dialogEl') dialogEl!: ElementRef<HTMLDialogElement>;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible']) {
      setTimeout(() => {
        if (this.visible) this.dialogEl?.nativeElement?.showModal();
        else this.dialogEl?.nativeElement?.close();
      });
    }
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.onHidden.emit();
  }

  onClose() {
    if (this.visible) this.close();
  }

  onBackdropClick(event: MouseEvent) {
    if (this.hideOnOutsideClick && event.target === this.dialogEl.nativeElement) {
      this.close();
    }
  }
}
